import { usePwa } from '../PwaProvider';
export const useConnectivity = () => { const { connectivity, checkConnectivity } = usePwa(); return { ...connectivity, retry: checkConnectivity }; };
